export const AMOUNT_ERROR = "Сумма операции должна быть больше 10₽ и меньше "

export const clearInputAmount = (amount: string) =>
  amount.replace(/\s/g, "").replace(/^0+/, "")

export const validateAmount = (
  value: string,
  limit: number,
  balance?: number,
) => {
  const clearValue = clearInputAmount(value).replace(",", ".")
  if (Number(clearValue) < 10 || Number(clearValue) > limit)
    return { result: true, reason: "limit" }
  if (balance && Number(clearValue) > balance)
    return { result: true, reason: "balance" }
  return { result: false, reason: "" }
}

export function formatNumber(n: string) {
  return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}

export function formatCurrency(value: string) {
  if (value.indexOf(",") >= 0) {
    const decimalPos = value.indexOf(",")
    let leftSide = value.substring(0, decimalPos)
    let rightSide = value.substring(decimalPos)
    leftSide = formatNumber(leftSide)
    rightSide = formatNumber(rightSide)
    rightSide = rightSide.substring(0, 2)

    return `${leftSide},${rightSide}`
  }

  return `${formatNumber(value)}`
}
